
import Vue from 'vue';
import Modal from '@/components/layout/modal.vue';

export default Vue.extend({
  name: 'BeforeAfterLicenseAgreementModal',
  components: {
    Modal,
  },
  methods: {
    close() {
      this.$emit('close');
    },
  },
});
